export const PRODUCTS = [
  {
    title: 'Email Marketing',
    slug: '/solutions/email-marketing',
  },
  {
    title: 'Email API',
    slug: '/solutions/email-api',
  },
  {
    title: 'Twilio Programmable SMS',
    slug: 'https://twilio.com/sms',
  },
  {
    title: 'Expert Services',
    slug: '/solutions/expert-services',
  },
  {
    title: 'One Platform Solution',
    slug: '/solutions',
  },
  {
    title: 'Pricing',
    slug: '/pricing',
  },
];

export const SENDGRID_IS_FOR = [
  {
    title: 'Startups',
    slug: '/accelerate',
  },
  {
    title: 'Enterprises',
    slug: '/solutions/enterprises',
  },
  {
    title: 'High Volume Senders',
    slug: '/contact',
  },
  {
    title: 'Marketers',
    slug: '/solutions/email-marketing',
  },
  {
    title: 'Ecommerce',
    slug: '/solutions/ecommerce',
  },
  {
    title: 'Developers',
    slug: '/solutions/email-api',
  },
];

export const RESOURCES = [
  {
    title: 'Guides',
    slug: '/resources/guides',
  },
  {
    title: 'Blog',
    slug: '/blog',
  },
  {
    title: 'Videos & Podcasts',
    slug: '/resources/videos-podcasts',
  },
  {
    title: 'Webcasts',
    slug: '/resources/webcasts',
  },
  {
    title: 'Knowledge Center',
    slug: 'https://sendgrid.com/docs',
  },
  {
    title: 'Status',
    slug: 'https://status.sendgrid.com',
  },
];

export const DEVELOPERS = [
  {
    title: 'Start in 5 Minutes',
    slug:
      'https://sendgrid.com/docs/for-developers/sending-email/api-getting-started',
  },
  {
    title: 'API Reference',
    slug: 'https://sendgrid.com/docs/api-reference',
  },
  {
    title: 'SMTP Service',
    slug: '/solutions/email-api/smtp-service/',
  },
  {
    title: 'Libraries',
    slug: 'https://github.com/sendgrid',
  },
  {
    title: 'Event Webhooks',
    slug: 'https://sendgrid.com/docs/for-developers/tracking-events/event',
  },
  {
    title: 'Integration & Partners',
    slug: '/partners',
  },
];

export const COMPANY = [
  {
    title: 'About Twilio SendGrid',
    slug: '/about',
  },
  {
    title: 'Our Team',
    slug: '/team',
  },
  {
    title: 'Our Customers',
    slug: '/customers',
  },
  {
    title: 'Careers at Twilio',
    slug: '/careers',
  },
  {
    title: 'Twilio Press & Media',
    slug: 'https://www.twilio.com/press',
  },
  {
    title: 'Trust & Security',
    slug: '/policies/security',
  },
];
